/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;
      this.ticking = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.checkVisible();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    checkVisible() {
      const y = window.scrollY;
      if (y > this.pageHeight) {
        this.classList.add('back-to-top--active');
      } else {
        this.classList.remove('back-to-top--active');
      }
    }

    handleClick() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
  customElements.define('back-to-top', BackToTop);
}
// UPDATED 8/14 TO IMPROVE PERFORMANCE - MAX 